export const FeaturesList = {
  AuditLogs: 'audit_logs',
  PostSeoDetails: 'post_seo_details',
  PostEmbedCreator: 'post_embed_creator',
  NewAdminPanel: 'new_admin_panel',
  NewModerationPanel: 'new_moderation_panel',
  CustomProfileFields: 'custom_profile_fields',
  PageCustomizer: 'page_customizer',
}
